<template>
  <div>
    <div class="comment">
      <span>
        <i class="admin-badge" v-if="comment.author[3] === 'Admin'"></i>
        {{ comment.author[0] }}
      </span>
      <p>{{ comment.text }}</p>
      <div class="tools">
        <button>
          <input
            type="checkbox"
            :id="comment._id + '-comment-like-button'"
            @change="editLikes($event)"
            :checked="comment.likes.includes(thisUser.name)"
          />
          <label :for="comment._id + '-comment-like-button'"></label>
          {{ comment.likes.length }}
        </button>
        <button
          v-if="comment.onPost"
          class="fas fa-reply"
          @click="reply()"
        ></button>
        <button
          class="fas fa-trash"
          v-if="thisUser.isAdmin || comment.author[0] === thisUser.name"
          @click="deleteComment()"
        ></button>
      </div>
    </div>
    <div class="replies">
      <slot><!-- replies will go here --></slot>
    </div>
    <transition name="opacity">
      <w-popup ref="popup" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import WPopup from "./WPopup.vue";
export default {
  components: { WPopup },
  name: "WComment",
  props: ["commentObject", "parentComment"],
  data() {
    return {
      comment: JSON.parse(this.commentObject),
    };
  },
  computed: {
    thisUser() {
      return this.$store.state.user;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Posts;
    },
  },
  methods: {
    reply() {
      this.$emit("reply-to", [
        this.comment._id,
        `${this.comment.author[0]} : ${this.comment.text}`,
      ]);
    },
    async deleteComment() {
      const confirmationResult = await this.$refs.popup.show({
        message: this.appVocubulary.deleteComment,
        confirmText: "DELETE",
        cancelText: "CANCEL",
      });
      if (confirmationResult) {
        if (this.comment.onPost) {
          // means that the comment is not reply
          await axios.delete(
            `${this.$store.state.backend_link}comments/${this.comment._id}`
          );
        } else {
          await axios.delete(
            `${this.$store.state.backend_link}comments/reply/${this.parentComment}/${this.comment._id}`
          );
        }
        this.$emit("refresh");
      }
    },
    async editLikes(e) {
      let likesCheck = e.currentTarget.parentElement.childNodes[0],
        likesText = e.currentTarget.parentElement.childNodes[2];
      const operation = likesCheck.checked ? "plus" : "minus";
      if (operation === "plus") {
        likesText.textContent = Number.parseInt(likesText.textContent) + 1;
      } else {
        likesText.textContent = Number.parseInt(likesText.textContent) - 1;
      }
      if (this.comment.onPost) {
        await axios.put(
          `${this.$store.state.backend_link}comments/${this.comment._id}`,
          {
            name: this.thisUser.name,
            operation: operation,
          }
        );
      } else {
        await axios.put(
          `${this.$store.state.backend_link}comments/reply/${this.parentComment}/${this.comment._id}`,
          {
            name: this.thisUser.name,
            operation: operation,
          }
        );
      }
      this.$emit("refresh");
      // const num = this.comment.onPost ? 1 : 0;
      // if (operation === "plus") {
      //   likesText.textContent = comment.data.likes.length + 1;
      // } else {
      //   likesText.textContent = comment.data.likes.length - 1;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.replies {
  width: 100%;
  padding-left: 30px;
}

.comment {
  direction: ltr;
  position: relative;
  width: fit-content;
  max-width: calc(100% - 40px);
  margin: 10px 0;
  background-color: var(--tent);
  border-radius: 16px;
  padding: 14px;
  font-size: 0.9em;
  word-wrap: break-word;

  .tools {
    position: absolute;
    top: 0;
    right: -40px;
    width: 40px;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: center;
    font-size: 0.9em;
    button {
      margin: 0;
      padding: 4px;
      background: transparent;
      color: var(--text);
      font-size: 0.9em;
      label {
        margin: 0 2px;
        transform: translateX(-2px);
        &:before {
          content: "\f004";
          color: var(--text);
          font-weight: 400;
          font-family: "Font Awesome 5 Free";
          transition: all 0.2s linear;
        }
      }
    }
    input {
      display: none;
      &:checked + label {
        &:before {
          color: red;
          font-weight: 900;
        }
      }
    }
  }

  span {
    font-weight: bold;
  }

  p {
    width: 100% !important;
    margin: 10px 0 0 !important;
    padding: 0;
  }
  .comment-deleter {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
